module.exports = "/images/arrow-left-icon.svg?f998e7dc170889739dc324029a089f2b";